import { useDeleteProgrammesMutation } from "@common/api/maintenance-programme"
import { handleError } from "@common/utils"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeleteDialog } from "@/components/layout/list-table-menu"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/maintenance-programmes/delete/$programmeId",
)({
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "maintenance_programme:delete", "/"),
  component: DeleteProgrammeDialog,
})

function DeleteProgrammeDialog(): React.ReactElement {
  const { programmeId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const remove = useDeleteProgrammesMutation()

  const close = () => navigate({ to: "/maintenance-programmes", search: true })

  return (
    <DeleteDialog
      noun="maintenance programme"
      pending={remove.isPending}
      onCancel={close}
      onConfirm={() =>
        remove.mutate(
          { programmesBulkChange: { programme_ids: [programmeId] } },
          {
            onSuccess: ({ missing }) => {
              if (missing.length > 0) {
                showToast(
                  "Error",
                  "Maintenance programme could not be deleted.",
                  "error",
                )
                return
              }
              showToast("Deleted", "Maintenance programme deleted.", "success")
              close()
            },
            onError: (error) => handleError(error, showToast),
          },
        )
      }
    />
  )
}
